var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEraser = function SvgEraser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    fillRule: "evenodd",
    d: "M6.02147 5.08217 4.06066 7.04298 6.14468 9.127C6.63283 9.61515 7.42429 9.61515 7.91244 9.127L8.98937 8.05007 6.02147 5.08217ZM13.7345 5.37949C13.7004 5.44405 13.6561 5.50468 13.6017 5.55903L8.9731 10.1877C7.89916 11.2616 6.15796 11.2616 5.08402 10.1877L2.46967 7.57331C2.17678 7.28042 2.17678 6.80554 2.46967 6.51265L5.48708 3.49524C5.48842 3.49388 5.48977 3.49252 5.49112 3.49117L8.51254.469746C8.80544.176853 9.28031.176853 9.5732.469746L13.6018 4.49831C13.8403 4.73686 13.8846 5.09614 13.7345 5.37949ZM1.25 12.7966C1.25 12.3823 1.58579 12.0466 2 12.0466H12C12.4142 12.0466 12.75 12.3823 12.75 12.7966 12.75 13.2108 12.4142 13.5466 12 13.5466H2C1.58579 13.5466 1.25 13.2108 1.25 12.7966Z",
    clipRule: "evenodd"
  })));
};
export default SvgEraser;